<div [class]="className">
    <span>{{ messageObj.message }}</span>
    <a [routerLink]="cartLink" *ngIf="messageObj.showBtn">Завершити покупку</a>
    <div class="cart-info-window-close" (click)="deleteMessage()"></div>
</div>